import React, { useContext, useEffect } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import DOMPurify from 'dompurify';
import CheckoutHeader from './components/CheckoutHeader';
import useMediaQuery from '../../utils/hooks/mediaQuery.hook';
import CheckoutForm from './components/CheckoutForm';
import ArticlesPreview from '../../components/ArticlesPreview';
import { CampaignContext } from '../../context/CampaignWrapper';
import CheckoutSkeleton from './components/skeletons/CheckoutSkeleton';

const CheckoutContainer = () => {
  const {
    campaign: {
      textConfig, isSellingEnabled,
    } = { textConfig: undefined, isSellingEnabled: true },
    loading,
  } = useContext(CampaignContext);
  const { isMobile } = useMediaQuery();
  const [translate] = useTranslation();

  useEffect(() => () => toast.dismiss());

  if (loading) return <CheckoutSkeleton />;

  return (
    <div className="min-vh-100 d-flex flex-column">
      <CheckoutHeader />

      {!isSellingEnabled && textConfig?.sellingDisabled ? (
        <Container className="my-5">
          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(textConfig?.sellingDisabled) }} />
        </Container>
      ) : (
        <Container>
          <Row className="my-md-5">
            <Col xs={12} md={6}>
              <div className="checkout-section">
                {!isMobile && (
                <div className="checkout-section-title py-3">
                  <h4 className="mb-0">
                    {translate('COMPONENTS.CHECKOUT_CONTAINER.PERSONAL_INFO')}
                  </h4>
                </div>
                )}
                <CheckoutForm />
              </div>
            </Col>
            {!isMobile && (
            <Col md={6}>
              <div className="checkout-section">
                <div className="checkout-section-title py-3">
                  <h4 className="mb-0">
                    {translate('COMPONENTS.CHECKOUT_CONTAINER.YOUR_ORDER')}
                  </h4>
                </div>
                <ArticlesPreview />
              </div>
            </Col>
            )}
          </Row>
        </Container>
      )}
    </div>
  );
};

export default CheckoutContainer;
